/** No dependencies: the Toaster chunk loads on the first toast() call, which is queued until it mounts. */
let activated = false;
const activationListeners = new Set<() => void>();

export function activateToaster() {
	if (activated) return;
	activated = true;
	for (const fn of activationListeners) fn();
	activationListeners.clear();
}

export function onToasterActivated(fn: () => void): () => void {
	if (activated) {
		fn();
		return () => {};
	}
	activationListeners.add(fn);
	return () => {
		activationListeners.delete(fn);
	};
}

let toasterMounted = false;
const pendingToasts: Array<() => void> = [];

export function enqueueToast(fn: () => void) {
	if (toasterMounted) {
		fn();
	} else {
		pendingToasts.push(fn);
	}
}

export function flushPendingToasts() {
	toasterMounted = true;
	const pending = pendingToasts.splice(0);
	for (const fn of pending) fn();
}
